import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Layout } from 'components/Layout'
import { Header } from 'components/Header'
import { RecipeRoot } from './components/styles'
import { RecipeDetailHero } from './components/RecipeDetailHero'
import { Benefits } from './components/Benefits'
import { Ingredients } from './components/Ingredients'
import { Reviews } from '../components/Reviews/Reviews'
import { Compare } from '../components/Compare/Compare'
import { RecipeFooter } from '../components/RecipeFooter/RecipeFooter'
import { Expect } from './components/Expect'
import { Explore } from './components/Explore'
import { RecipeType } from 'features/Recipes/types'
import heroChicken from '../../../../public/assets/recipes/categories/individual/hero-chicken.jpg'
import heroBeef from '../../../../public/assets/recipes/categories/individual/hero-beef.png'
import heroVenison from '../../../../public/assets/recipes/categories/individual/hero-venison.png'
import heroDuck from '../../../../public/assets/recipes/categories/individual/hero-duck.png'
import heroTurkey from '../../../../public/assets/recipes/categories/individual/hero-turkey.png'
import heroLamb from '../../../../public/assets/recipes/categories/individual/hero-lamb.png'
import chickenBadge from '../../../../public/assets/recipes/categories/individual/chicken-badge.png'
import beefBadge from '../../../../public/assets/recipes/categories/individual/beef-badge.png'
import duckBadge from '../../../../public/assets/recipes/categories/individual/duck-badge.png'
import venisonBadge from '../../../../public/assets/recipes/categories/individual/venison-badge.png'
import turkeyBadge from '../../../../public/assets/recipes/categories/individual/turkey-badge.png'
import lambBadge from '../../../../public/assets/recipes/categories/individual/lamb-badge.png'
import { IngredientMap } from './components/Ingredients/Ingredients'
import { Footer } from 'components/Footer'
import { ProductPageReviews } from 'fixtures/review'
type RecipeDetailProps = {
  recipe: RecipeType
}

const {
  venison,
  beefHeart,
  beefLiver,
  beefKidney,
  beefBone,
  vitamin,
  chickenHeart,
  chickenBacks,
  chickenLegs,
  chickenLiver,
  turkeyGizzards,
  turkeyTails,
  turkeyWings,
  turkeyLiver,
  lamb,
  duck,
} = IngredientMap

const {
  julie,
  cristin,
  barbara,
  autumn,
  diana,
  lori,
  nena,
  ashley,
  rachel,
  rebekah,
  seth,
  norman,
  peter,
  darlene,
  jen,
  mallia,
  jev,
  teresa,
} = ProductPageReviews

export const Recipes = {
  chicken: {
    heroThumb: heroChicken,
    badge: chickenBadge,
    ingredients: [chickenHeart, chickenBacks, chickenLegs, chickenLiver, vitamin],
    reviews: [julie, cristin, barbara],
  },
  beef: {
    heroThumb: heroBeef,
    badge: beefBadge,
    ingredients: [beefHeart, beefLiver, beefKidney, beefBone, vitamin],
    reviews: [mallia, jev, teresa],
  },
  venison: {
    heroThumb: heroVenison,
    badge: venisonBadge,
    ingredients: [venison, beefHeart, beefLiver, beefKidney, beefBone, vitamin],
    reviews: [autumn, diana, lori],
  },
  duck: {
    heroThumb: heroDuck,
    badge: duckBadge,
    ingredients: [duck, turkeyGizzards, turkeyTails, turkeyLiver, vitamin],
    reviews: [nena, ashley, rachel],
  },
  turkey: {
    heroThumb: heroTurkey,
    badge: turkeyBadge,
    ingredients: [turkeyTails, turkeyGizzards, turkeyWings, turkeyLiver, vitamin],
    reviews: [peter, darlene, jen],
  },
  lamb: {
    heroThumb: heroLamb,
    badge: lambBadge,
    ingredients: [lamb, beefHeart, beefLiver, beefKidney, beefBone, vitamin],
    reviews: [rebekah, seth, norman],
  },
}

export const RecipeDetail = ({ recipe }: RecipeDetailProps) => {
  const { t } = useTranslation()

  const thumbnail = Recipes[recipe].heroThumb
  const badge = Recipes[recipe].badge
  const ingredients = Recipes[recipe].ingredients
  const reviews = Recipes[recipe].reviews

  const header = <Header hideBrandCopy />

  return (
    <RecipeRoot>
      <Layout hideCTA header={header}>
        <RecipeDetailHero thumbnail={thumbnail} recipe={recipe} />
        <Benefits badge={badge} recipe={recipe} />
        <Ingredients background="secondary-150" ingredients={ingredients} recipe={recipe} />
        <Explore hide={recipe} />
        <Compare />
        <Reviews background="secondary-100" reviews={reviews} icon={false} />
        <Expect />
        <RecipeFooter
          ctaLink="https://wefeedraw.gorgias.help/en-US"
          cta={t('recipes:overview.cta-4')}
          header={t('recipes:overview.contact')}
        />
        <Footer />
      </Layout>
    </RecipeRoot>
  )
}

RecipeDetail.displayName = 'RecipeDetail'
